import { apiFetch, type QueryValue } from '@/lib/api'
import type { ReportsService } from '@/services/contracts'
import type { GunlukTonajRow, Page, TartimDistinctQuery, TartimRow } from '@/types/models'

/**
 * Alan adları backend'in `rapor.v_tartim` / `rapor.v_gunluk_tonaj` yansımalarıyla
 * birebir aynı (sözleşme §7) — dönüştürme gerekmiyor, yalnızca tip iddiası.
 * Sorgu tipleri (`TartimQuery`/`TonajQuery`) somut arayüzler olduğu için `apiFetch`'in
 * indeks imzalı `Record<string, QueryValue>` parametresine doğrudan atanamıyor —
 * alan bazında zaten uyumlu oldukları için tip iddiası yeterli.
 */
export const httpReportsService: ReportsService = {
  async tartim(query) {
    return apiFetch<Page<TartimRow>>('/reports/tartim', {
      query: query as unknown as Record<string, QueryValue>,
    })
  },

  async tonaj(query) {
    return apiFetch<GunlukTonajRow[]>('/reports/tonaj', {
      query: query as unknown as Record<string, QueryValue>,
    })
  },

  async tartimDistinct(query: TartimDistinctQuery) {
    return apiFetch<string[]>('/reports/tartim/distinct', {
      query: query as unknown as Record<string, QueryValue>,
    })
  },
}
